class EventConflictError extends Error {
	constructor(message: string) {
		super(message);
		this.name = 'EventConflictError';
	}
}

export default EventConflictError;
